
import React from 'react';
import { Shield, Award, Users } from 'lucide-react';

const ServicesFeatures = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="flex flex-col items-center text-center">
            <div className="bg-brand-trophy-gold/10 p-4 rounded-full mb-4">
              <Shield className="h-8 w-8 text-brand-trophy-gold" />
            </div>
            <h3 className="text-lg font-semibold mb-2 text-brand-charcoal-gray">Insured</h3>
            <p className="text-gray-600 text-sm">Fully insured contractors with comprehensive coverage</p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="bg-brand-trophy-gold/10 p-4 rounded-full mb-4">
              <Award className="h-8 w-8 text-brand-trophy-gold" />
            </div>
            <h3 className="text-lg font-semibold mb-2 text-brand-charcoal-gray">Award-Winning Quality</h3>
            <p className="text-gray-600 text-sm">Recognized for excellence in roofing craftsmanship and service</p>
          </div>
          
          <div className="flex flex-col items-center text-center">
            <div className="bg-brand-trophy-gold/10 p-4 rounded-full mb-4">
              <Users className="h-8 w-8 text-brand-trophy-gold" />
            </div>
            <h3 className="text-lg font-semibold mb-2 text-brand-charcoal-gray">15+ Years Experience</h3>
            <p className="text-gray-600 text-sm">Serving North Carolina with trusted roofing expertise</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesFeatures;
